var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.248 -0.247)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0.248 0.248)",
    fill: "#5da8dd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.857 6.687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.673,24.741a5.488,5.488,0,0,0-5.313-4.132h-.477A8.228,8.228,0,1,0,12.961,28.8a.914.914,0,1,0,1.37-1.211,6.4,6.4,0,1,1,10.992-5.84.913.913,0,0,0,.885.686h1.151a3.657,3.657,0,0,1,1.749,6.868.914.914,0,1,0,.875,1.605,5.484,5.484,0,0,0,2.69-6.17Z",
    transform: "translate(-10.899 -15.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.915,34.4a.9.9,0,0,0-.143-.117c-.017-.011-.036-.019-.054-.029a.906.906,0,0,0-.1-.055c-.027-.011-.055-.017-.084-.026s-.057-.019-.087-.026a.92.92,0,0,0-.357,0c-.03.006-.058.017-.087.026s-.056.015-.084.026a.916.916,0,0,0-.1.055c-.018.01-.036.017-.053.029a.9.9,0,0,0-.143.117l-3.655,3.655a.914.914,0,1,0,1.293,1.293l2.1-2.1v6.021a.914.914,0,1,0,1.829,0V37.254l2.1,2.1a.914.914,0,0,0,1.293-1.293Z",
    transform: "translate(-19.291 -25.907)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.f1096784.svg";
export { ForwardRef as ReactComponent };